import { Injectable } from '@angular/core';

@Injectable()
export class ProductTocService {

    constructor() {}

    // Function to calculate the level count in the tocarray
    getTocNodeCount(rootNode) {
      let firstNode = rootNode[0];
      if(firstNode && firstNode.items && firstNode.items.length > 0) {
        return 1+this.getTocNodeCount(firstNode.items);
      }
      else {
        return 0;
      }
    }

    /* function to get leaf nodes of a node */
    getLeafNodeItems(node) {
        let leafNodeItems = [];
        let leafNodeRecFun = function(rootNode) {
            if(rootNode['item-type'] !== 'folder') {
                leafNodeItems.push(rootNode);
            }
            else {
                let nodeItems = rootNode.items;
                let parentSeq = rootNode.sequence;
                nodeItems.forEach((nodeItem, nodeIndex) => {
                    nodeItem.sequence = nodeIndex + 1;
                    if(parentSeq){
                        nodeItem.sequence = `${parentSeq}.${nodeItem.sequence}`;
                    }
                    
                    leafNodeRecFun(nodeItem);
                })
            }
        }
        leafNodeRecFun(node);
        return leafNodeItems;
    }

    /* Function to get lessons from unit */
    getLastFolderData(unit) {
        let lessons = [];
        let lessenLevelRecFun = function(unit) {
            if(unit.items && unit.items.length >0) {
                if(unit.items[0]['item-type'] !== 'folder') {
                    lessons.push(unit);
                }
                else {
                    let unitItems = unit.items;
                    unitItems.forEach(unitItem => {
                        lessenLevelRecFun(unitItem);
                    });
                }
            }
        }
        lessenLevelRecFun(unit);
        return lessons;
    }
}